import React from 'react'
import {Redirect, Route, Switch, withRouter} from 'react-router-dom'
import History from './History'
// import Deposit from './Deposits/Deposit'
// import DepositNotification from './Deposits/DepositNotification'
// import Withdraw from './Withdrawals/Withdraw'
// import Transfers from './Transfers'
// import DepositAction from './Deposits/DepositAction'
// import LocalDepositorTransfer from './LocalDepositorTransfer'

const PaymentRoutes = ({match: {path}}) =>(
  <Switch>
    <Redirect exact from={`${path}/deposit`} to={'/'} />
    <Redirect from={`${path}/:accountId/deposit`} to={'/'} />
    <Redirect exact from={`${path}/withdraw`} to={'/'} />
    <Redirect from={`${path}/:accountId/withdraw`} to={'/'} />
    <Redirect exact from={`${path}/transfer`} to={'/'} />
    <Redirect from={`${path}/:accountId/transfer`} to={'/'} />
    <Redirect exact from={`${path}/local-depositor-transfer`} to={'/'} />
    <Route exact path={`${path}/history`} component={History} />
    <Route path={`${path}`} component={History} />
  </Switch>
)

export default withRouter(PaymentRoutes)
